/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const GetConcernsIssueById = zod.object({
  "id": zod.string().uuid().optional(),
  "payload": zod.string().uuid().optional()
});

export type GetConcernsIssueById = zod.input<typeof GetConcernsIssueById>;
export type GetConcernsIssueByIdOutput = zod.output<typeof GetConcernsIssueById>;
